import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import router from'./route'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Pagination from "./components/pagination";
import marquee from 'marquee-components'
Vue.use(marquee );
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

Vue.config.productionTip = false
Vue.component('Pagination', Pagination)
Vue.use(ElementUI);
Vue.use(Antd);

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
